import React, { useEffect, useState } from 'react';
import { CForm, CFormInput, CFormLabel, CRow, CCol } from '@coreui/react-pro';
import Modal from 'src/components/utils/Modal';

const SMTPConfigModal = ({ visible, onClose, smtpDetails, onSubmit }) => {
    const [details, setDetails] = useState({
        provider: smtpDetails?.provider || '',
        host: smtpDetails?.host || '',
        port: smtpDetails?.port || '',
        encryption: smtpDetails?.encryption || '',
        fromName: smtpDetails?.fromName || '',
        senderEmail: smtpDetails?.senderEmail || '',
        replyToName: smtpDetails?.replyToName || '',
        replyToEmail: smtpDetails?.replyToEmail || '',
        auth: {
            user: smtpDetails?.auth?.user || '',
            pass: smtpDetails?.auth?.pass || ''
        }
    });

    useEffect(() => {
        setDetails({
            provider: smtpDetails?.provider || '',
            host: smtpDetails?.host || '',
            port: smtpDetails?.port || '',
            encryption: smtpDetails?.encryption || '',
            fromName: smtpDetails?.fromName || '',
            senderEmail: smtpDetails?.senderEmail || '',
            replyToName: smtpDetails?.replyToName || '',
            replyToEmail: smtpDetails?.replyToEmail || '',
            auth: {
                user: smtpDetails?.auth?.user || '',
                pass: smtpDetails?.auth?.pass || ''
            }
        });
    }, [smtpDetails]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'auth.user' || name === 'auth.pass') {
            const [parent, child] = name.split('.');
            setDetails((prevDetails) => ({
                ...prevDetails,
                [parent]: {
                    ...prevDetails[parent],
                    [child]: value
                }
            }));
        } else {
            setDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
            }));
        }
    };

    return (
        <Modal
            size="lg"
            title={<p className="app-font">SMTP Configuration</p>}
            onClose={onClose}
            visible={visible}
            content={
                <div>
                    <CForm>
                        <CRow className="mb-3">
                            <CCol md={6}>
                                <CFormLabel htmlFor="provider">SMTP Provider</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="provider"
                                    name="provider"
                                    value={details.provider || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter SMTP Provider"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="host">SMTP Host</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="host"
                                    name="host"
                                    value={details.host || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter SMTP Host"
                                />
                            </CCol>
                        </CRow>
                        <CRow className="mb-3">
                            <CCol md={6}>
                                <CFormLabel htmlFor="port">SMTP Port</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="port"
                                    name="port"
                                    value={details.port || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter SMTP Port"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="encryption">Encryption</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="encryption"
                                    name="encryption"
                                    value={details.encryption || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter Encryption (e.g., SSL/TLS)"
                                />
                            </CCol>
                        </CRow>
                        <CRow className="mb-3">
                            <CCol md={6}>
                                <CFormLabel htmlFor="fromName">From Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="fromName"
                                    name="fromName"
                                    value={details.fromName || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter From Name"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="senderEmail">From Email</CFormLabel>
                                <CFormInput
                                    type="email"
                                    id="senderEmail"
                                    name="senderEmail"
                                    value={details.senderEmail || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter From Email"
                                />
                            </CCol>
                        </CRow>
                        <CRow className="mb-3">
                            <CCol md={6}>
                                <CFormLabel htmlFor="replyToName">Reply To Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="replyToName"
                                    name="replyToName"
                                    value={details.replyToName || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter Reply To Name"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="replyToEmail">Reply To Email</CFormLabel>
                                <CFormInput
                                    type="email"
                                    id="replyToEmail"
                                    name="replyToEmail"
                                    value={details.replyToEmail || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter Reply To Email"
                                />
                            </CCol>
                        </CRow>
                        <CRow className="mb-3">
                            <CCol md={6}>
                                <CFormLabel htmlFor="auth.user">SMTP Login</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="auth.user"
                                    name="auth.user"
                                    value={details.auth?.user || ''}
                                    onChange={handleInputChange}
                                    placeholder="Enter SMTP Login"
                                />
                            </CCol>
                            <CCol md={6}>
                                <CFormLabel htmlFor="auth.pass">SMTP Password</CFormLabel>
                                <CFormInput
                                    type="password"
                                    id="auth.pass"
                                    name="auth.pass"
                                    value={details.auth?.pass || ''}
                                    onChange={handleInputChange}
                                    placeholder={smtpDetails?.hasPassword ? '••••••••  (leave blank to keep current)' : 'Enter SMTP Password'}
                                    autoComplete="new-password"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                    <div className="modal-footer">
                        <button
                            className="card-form-primary-btn flex-all-center"
                            onClick={() => {
                                // Strip empty auth.pass so the backend never interprets a blank
                                // field as "set password to empty string". This ensures the
                                // existing encrypted password is preserved when the user doesn't
                                // retype it, regardless of which backend branch is deployed.
                                const payload = { ...details };
                                if (payload.auth && !payload.auth.pass) {
                                    const { pass, ...authWithoutPass } = payload.auth;
                                    payload.auth = authWithoutPass;
                                }
                                // Remove the UI-only hasPassword flag before sending
                                delete payload.hasPassword;
                                onSubmit(payload);
                            }}
                        >
                            Save
                        </button>
                        <button
                            className="card-form-outline-btn flex-all-center"
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            }
        />
    );
};

export default SMTPConfigModal;
